import React, { useEffect, useRef, useState } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';
import Brand from './Brand';
import './Header.css';

const navigation = [
  ['Van rental', '/van-rental'],
  ['Van hire', '/van-hire'],
  ['Our vans', '/our-vans'],
  ['Electric & hybrid', '/electric-hybrid-vans'],
  ['Business & fleet', '/business-van-hire'],
  ['Contact', '/contact'],
];

function Header() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const menuButton = useRef(null);
  const location = useLocation();

  useEffect(() => { setMobileMenuOpen(false); }, [location.pathname, location.search]);

  useEffect(() => {
    if (!mobileMenuOpen) return undefined;
    const closeOnEscape = (event) => {
      if (event.key === 'Escape') {
        setMobileMenuOpen(false);
        menuButton.current?.focus();
      }
    };
    document.addEventListener('keydown', closeOnEscape);
    return () => document.removeEventListener('keydown', closeOnEscape);
  }, [mobileMenuOpen]);

  return (
    <header className="vanir-header">
      <div className="vanir-header__utility">
        <div className="vanir-header__utility-inner">
          <span>Based in Liverpool. Delivery available nationwide.</span>
          <div><Link to="/vehicle-sales">Vehicle sales</Link><a href="tel:01516731916">Call <strong>0151 673 1916</strong></a></div>
        </div>
      </div>
      <div className="vanir-header__main">
        <Link to="/" className="vanir-header__logo" aria-label="Vanir Motor Group"><Brand /></Link>
        <nav className="vanir-header__desktop-nav" aria-label="Primary">
          {navigation.map(([label, path]) => <NavLink key={path} to={path}>{label}</NavLink>)}
        </nav>
        <Link className="vanir-header__quote" to="/request-a-quote">Request a quote <span aria-hidden="true">↗</span></Link>
        <button type="button" ref={menuButton} className="vanir-header__menu-toggle" aria-label={mobileMenuOpen ? 'Close menu' : 'Open menu'} aria-expanded={mobileMenuOpen} aria-controls="vanir-mobile-navigation" onClick={() => setMobileMenuOpen(!mobileMenuOpen)}>
          <svg viewBox="0 0 24 24" width="24" height="24" aria-hidden="true">{mobileMenuOpen ? <path d="m6 6 12 12M18 6 6 18" /> : <path d="M4 6h16M4 12h16M4 18h16" />}</svg><span>Menu</span>
        </button>
      </div>
      {mobileMenuOpen && <nav className="vanir-header__mobile-nav" id="vanir-mobile-navigation" aria-label="Mobile">
        {navigation.map(([label, path]) => <NavLink key={path} to={path}>{label}<span aria-hidden="true">↗</span></NavLink>)}
        <Link to="/vehicle-sales">Vehicle sales<span aria-hidden="true">↗</span></Link>
        <Link className="vanir-header__mobile-quote" to="/request-a-quote">Request a quote</Link>
        <a className="vanir-header__mobile-call" href="tel:01516731916">Call 0151 673 1916</a>
      </nav>}
    </header>
  );
}

export default Header;
